import classNames from "classnames";

export const radioWrapper = classNames([
    "w-full",
    "p-10",
    "bg-[#E3E4E6]",
])

export const radioContainer = classNames([
    "w-full",
    "max-w-[900px]",
    "ml-auto",
    "mr-auto",
    "mt-14",
    "pl-4",
    "pr-4",
])

export const radioItem = classNames([
    /* mobile-lg */
    "mobile-lg:flex-row",
    "mobile-lg:items-center",
    "mobile-lg:justify-start",
    "mobile-lg:text-left",
    /* All */
    "text-center",
    "flex",
    "flex-col",
    "items-center",
    "justify-center",
    "mb-5",
    "shadow-lg",
    "p-10",
    "rounded-lg"
])

export const radioImg = classNames([
    /* mobile-lg */
    "mobile-lg:mb-0",
    "mobile-lg:mr-10",
    "mobile-lg:ml-0",
    /* All */
    "mb-5",
    "w-full",
    "max-w-[130px]",
    "mr-auto",
    "ml-auto",
])

export const radioTitle = classNames([
    "text-lg",
    "font-bold",
    "hover:text-accent",
    "hover:decoration-1",
    "hover:underline",
])

export const  radioContent = classNames([
    "text-sm",
    "mt-2"
])